import React from 'react';

export default function Score(props){
  return (<span>{props.score.home}&nbsp;-&nbsp;{props.score.away}</span>);
}